import React from "react";
import { Container, Wrapper } from "components/BottomBar/components";
import { DebuggerTrigger } from "components/editorComponents/Debugger";
import { RunHistoryTrigger } from "./WorkflowRunHistory/RunHistoryTrigger";
import { useCurrentAppState } from "IDE/hooks/useCurrentAppState";
import { EditorState } from "IDE/enums";
import HelpButton from "pages/Editor/HelpButton";

export function BottomBar() {
  const editorState = useCurrentAppState();

  return (
    <Container>
      <Wrapper>
        <div data-testid="t--switch-env" />
      </Wrapper>
      <Wrapper>
        <DebuggerTrigger />
        {editorState === EditorState.EDITOR && <RunHistoryTrigger />}
        <HelpButton />
      </Wrapper>
    </Container>
  );
}
